import { VerificationMark } from '../ui/VerificationMark'
import { useI18n } from '../i18n/I18nProvider'

export function Brand() {
  return (
    <span className="brand">
      <span className="brand__name"><strong>TS</strong> Auto</span>
    </span>
  )
}

export function BrandSignature() {
  const { t } = useI18n()
  return <VerificationMark label={t('sandbox.verification')} />
}
